import { FileAttachmentDTO } from "./../file-attachment-dto";
import { AdHocInstructionDTO } from "./adhoc-instruction-dto";
import { AdHocInstructionRetailD2Forecast } from "./adhoc-instruction-retail-d2-forecast";

export class AdHocInstructionRetailDTO extends AdHocInstructionDTO {
    public forecasts : AdHocInstructionRetailD2Forecast[] = [];
}
